var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unauthorized-container"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-ban"})]),_c('span',{staticClass:"tip"},[_vm._v("很抱歉，你无权访问此页面！🙅‍♀️")])])
}]

export { render, staticRenderFns }